export const releases = [
    { name: 'VA- ENOUGH! Fundraiser for Dr. Ghassan Abu Sittah’s Children Fund', category: 'label', label: 'Dreaming Live', year: 2024, link: 'https://dreaminglive.bandcamp.com/album/enough' },
    { name: 'Mayss - On this land ! على هذه الأرض', category: 'music', label: 'Dreaming Live', year: 2024, link: 'https://www.youtube.com/watch?v=GVrIJJ43i98' },
    { name: 'The Birth ov Heli & Thea', category: 'music', label: 'Unreleased', year: 2021, link: 'https://soundcloud.com/dreaming-live/thea' }
];
